const className = 'Template'

export default class Template {
  constructor (Parse) {
    this.Parse = Parse
  }

  /**
   * Get a Template query to find all templates
   */
  getAll () {
    var Class = this.Parse.Object.extend(className)
    var query = new this.Parse.Query(Class)
    query.include('data')
    return query
  }

  /**
   * Get a template query
   * @param brand template brand, parse object
   */
  getByBrand (brand) {
    var Class = this.Parse.Object.extend(className)
    var query = new this.Parse.Query(Class)
    query.equalTo('brand', brand)
    query.include('data')
    return query
  }

  getByBrandAndScreenType (brand, screenType) {
    var Class = this.Parse.Object.extend(className)
    var query = new this.Parse.Query(Class)
    query.equalTo('brand', brand)
    query.equalTo('screenType', screenType)
    query.include('data')
    return query
  }

  onError (object, error) {
    console.log('Error', error)
  }
}


//////////////////
// WEBPACK FOOTER
// ./parse-model/Template.mjs
// module id = Si1J
// module chunks = 0